// 3ds第一个中间页显示
export const EVENT_FG_SDK_CHECKOUT_3DS_PAGE_SHOW =
  "fp_sdk_checkout_3ds_page_show";

// 3ds验证第一个中间页完成加载，跳转离开
export const EVENT_FG_SDK_CHECKOUT_3DS_PAGE_LEAVE =
  "fp_sdk_checkout_3ds_page_leave";

// 3ds验证结果页（第二个中间页）的结果得到
export const EVENT_FG_SDK_CHECKOUT_3DS_RESULT_SHOW =
  "fp_sdk_checkout_3ds_result_show";

// 3ds验证结果页（第二个中间页）的页面展示
export const EVENT_FG_SDK_CHECKOUT_3DS_RESULT_PAGE_SHOW =
  "fp_sdk_checkout_3ds_result_page_show";

// 3ds 前端全流程状态机上报
export const EVENT_FG_SDK_CHECKOUT_3DS_STATUS = "fp_sdk_checkout_3ds_status";

// OnePage 3ds 中用户异常离开打点
export const EVENT_FG_SDK_CHECKOUT_3DS_UNEXPECTED_LEAVE =
  "fp_sdk_checkout_3ds_unexpected_leave";

// 支付/绑卡结果轮询中间页，结果请求完成，跳转至 return_url
export const EVENT_FP_SDK_CHECKOUT_LAND_RESULT_BEFORE_JUMP =
  "fp_sdk_checkout_land_result_before_jump";

// 支付结果轮询中间页页面展示
export const EVENT_FP_SDK_CHECKOUT_PAY_POLLING_RESULT_SHOW =
  "fp_sdk_checkout_pay_polling_result_show";

// 绑卡结果轮询中间页页面展示
export const EVENT_FP_SDK_CHECKOUT_BIND_POLLING_RESULT_SHOW =
  "fp_sdk_checkout_bind_polling_result_show";

// 离开页面
export const EVENT_FP_SDK_CHECKOUT_LEAVE = "fp_sdk_checkout_leave";

// 返回页面
export const EVENT_FP_SDK_CHECKOUT_RETURN = "fp_sdk_checkout_return";

// OVO中间页挽回弹窗展示（仅Mobile有上报）
export const EVENT_FP_SDK_CHECKOUT_OVO_POPUP_SHOW =
  "fp_sdk_checkout_ovo_popup_show";

// OVO中间页挽回弹窗点击
export const EVENT_FP_SDK_CHECKOUT_OVO_POPUP_CLICK =
  "fp_sdk_checkout_ovo_popup_click";

// OVO中间页离开/暂离
export const EVENT_FP_SDK_CHECKOUT_OVO_WAITING_PAGE =
  "fp_sdk_checkout_ovo_waiting_page_leave";

/**
 * 3ds flow type
 *  1. 新1 -> 结果页
 *  2. 新1 -> 3ds验证页 -> 新2
 *  3. 新1 -> 3ds验证页 -> 老2
 *  5. 老1 -> 3ds验证页 -> 老2"
 */

export const NEWFLOW_ONLY = 1;
export const NEWFLOW_TO_NEWFLOW = 2;
export const NEWFLOW_TO_OLDFLOW = 3;
export const OLDFLOW_TO_OLDFLOW = 4;
